import React from 'react';
import { JournalExplorer } from './JournalExplorer';

export const LedgerB2c = () => <JournalExplorer segment="B2C" />;

export const LedgerB2b = () => <JournalExplorer segment="B2B" />;
